import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  text: 'Hermoso lugar, súper tranquilo y con una vista increíble. Ideal para desconectar de la ciudad.',
  author: 'María L.'
}, {
  text: 'Las cabañas muy cómodas y el desayuno excelente. La atención de los dueños es para destacar.',
  author: 'Carlos y Familia'
}, {
  text: 'Ideal para descansar en familia y disfrutar de la naturaleza. Volveremos sin dudarlo.',
  author: 'Julieta G.'
}];
export function Testimonials() {
  return <section className="py-24 bg-sand" data-id="element-255">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-256">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-257">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-5xl text-olive-dark mb-6" data-id="element-258">
            Quienes nos visitan nos eligen para volver
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-lg text-charcoal-light" data-id="element-259">
            La tranquilidad del lugar, la calidez de las cabañas y el entorno
            natural hacen de cada estadía una experiencia para recordar.
          </motion.p>
        </div>

        <div className="flex flex-col md:grid md:grid-cols-3 gap-4 md:gap-8" data-id="element-260">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white p-5 md:p-8 rounded-xl md:rounded-2xl shadow-sm border border-sand-dark/20 relative" data-id="element-261">
              <div className="flex gap-1 text-earth mb-3 md:mb-6" data-id="element-262">
                {[...Array(5)].map((_, i) => <Star key={i} size={14} className="md:w-5 md:h-5" fill="currentColor" data-id="element-263" />)}
              </div>
              <p className="text-charcoal-light italic mb-3 md:mb-6 text-sm md:text-lg leading-snug md:leading-normal" data-id="element-264">
                "{testimonial.text}"
              </p>
              <p className="font-medium text-olive-dark text-xs md:text-base" data-id="element-265">
                {testimonial.author}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}